import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Link from "next/link";
const ACCORDION_DATA = [{
  title: "Peer Review Guidelines",
  content: "All submissions undergo a rigorous double-blind peer review process. Reviewers evaluate manuscripts based on originality, methodological rigor, historical accuracy, and relevance to the diaspora discourse. Authors can expect initial feedback within 8-10 weeks."
}, {
  title: "DOI & ISSN Assignment",
  content: "Every accepted paper is assigned a unique Digital Object Identifier (DOI) via Crossref, ensuring permanent discoverability. The Girmitiya Council Journal operates under an internationally recognized ISSN for both digital and print editions."
}, {
  title: "Open Access Policy",
  content: "We believe in the democratization of knowledge. All publications under the Council's imprint follow a strict Platinum Open Access model, meaning no paywalls for readers and no article processing charges (APCs) for authors."
}, {
  title: "Copyright & Licensing",
  content: "Authors retain full copyright of their work. All articles are distributed under a Creative Commons Attribution-NonCommercial (CC BY-NC 4.0) license, allowing free sharing and adaptation for non-commercial purposes with proper attribution."
}, {
  title: "Author Profiles & Registry",
  content: "Contributing scholars are automatically inducted into the Global Girmitiya Researchers Registry. Your personal author profile will list your affiliations, ORCID iD, and a consolidated archive of your published works."
}];
const SubmissionPortal = () => {
  const $ = _c(10);
  const [openIdx, setOpenIdx] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-8 sm:mb-10 md:mb-12"><h2 className="font-display text-[30px] sm:text-[36px] md:text-[40px] lg:text-[52px] text-[#0F1C2E] leading-[1.1] mb-4 sm:mb-6">{"Submission & "}<em className="text-[#C9A84C] italic">Access Policies</em></h2><p className="font-body text-[14px] sm:text-[16px] text-[#4C596B] font-light max-w-[500px] leading-[1.7]">We uphold the highest academic standards. Review our publishing frameworks below before submitting your manuscript to the editorial board.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== openIdx) {
    t1 = ACCORDION_DATA.map((item, idx) => <div key={idx} className="border-b border-[#0F1C2E]/10"><button onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)} className="w-full text-left py-4 sm:py-5 md:py-6 flex items-center justify-between group"><h3 className={`font-display text-[18px] sm:text-[20px] md:text-[22px] lg:text-[26px] transition-colors ${openIdx === idx ? "text-[#DF6D2A]" : "text-[#0F1C2E] group-hover:text-[#DF6D2A]"}`}>{item.title}</h3><span className={`text-[20px] transition-transform duration-300 ${openIdx === idx ? "rotate-45 text-[#DF6D2A]" : "text-[#0F1C2E]/40"}`}>+</span></button><AnimatePresence>{openIdx === idx && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: "auto",
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="overflow-hidden"><p className="font-body text-[13px] sm:text-[15px] text-[#4C596B] leading-[1.7] sm:leading-[1.8] pb-5 sm:pb-6 md:pb-8 pr-2 sm:pr-4 md:pr-8">{item.content}</p></motion.div>}</AnimatePresence></div>);
    $[1] = openIdx;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="w-full lg:w-[55%]">{t0}<div className="border-t border-[#0F1C2E]/10">{t1}</div></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div><div className="w-10 h-10 sm:w-12 sm:h-12 border border-[#DF6D2A]/30 rounded-full flex items-center justify-center mb-5 sm:mb-6 md:mb-8"><span className="font-display text-[20px] sm:text-[24px] text-[#DF6D2A] italic">§</span></div><h3 className="font-display text-[28px] sm:text-[32px] md:text-[36px] text-[#F4EFE6] leading-[1.1] mb-4 sm:mb-6">Submit Your Research</h3><p className="font-body text-[13px] sm:text-[15px] text-white/60 leading-[1.6] sm:leading-[1.7] mb-6 sm:mb-8 md:mb-10">The Editorial Board is currently accepting manuscripts for Vol 2, Issue 1. Submissions must adhere to the Chicago Manual of Style. Please attach your abstract, manuscript, and author bio.</p></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="border border-dashed border-white/20 p-4 sm:p-6 text-center hover:border-[#DF6D2A]/50 transition-colors cursor-pointer bg-white/[0.02]"><span className="font-body text-[10px] tracking-[0.2em] uppercase text-white/40 block mb-2">Upload Manuscript</span><span className="font-body text-[12px] text-white/80">.PDF or .DOCX format (Max 20MB)</span></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="w-full lg:w-[45%]"><div className="bg-[#0F1C2E] p-6 sm:p-8 md:p-10 lg:p-14 border border-[#C9A84C]/20 shadow-[0_20px_60px_rgba(15,28,46,0.1)] h-full flex flex-col justify-between">{t3}<div className="space-y-6">{t4}<Link href="/contact" className="block w-full"><button className="w-full font-body py-4 btn-primary text-[12px] tracking-[0.15em] uppercase hover:bg-white hover:text-[#0F1C2E] transition-colors duration-300">Access Submission Form</button></Link><p className="font-body text-[10px] tracking-widest text-center text-white/40 uppercase">Or email: submissions@girmitiyacouncil.in</p></div></div></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2) {
    t6 = <section className="bg-[#EBE5D9] py-16 sm:py-24 md:py-32 relative"><div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12"><div className="flex flex-col lg:flex-row gap-10 sm:gap-12 lg:gap-24">{t2}{t5}</div></div></section>;
    $[8] = t2;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default SubmissionPortal;